import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesRenin = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
Medline<br />
https://www.kidney-international.org/article/S0085-2538(22)00911-5/fulltext (2023)
https://www.news-medical.net/health/What-is-the-Renin-Angiotensin-Aldosterone-System.aspx#:~:text=The%20renin%2Dangiotensin%2Daldosterone%20system%20(RAAS)%2C%20or,RAAS%20can%20improve%20these%20conditions <br />    
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8811286/#:~:text=Endothelial%20dysfunction%20may%20contribute%20to,development%20and%20complications%20of%20hypertension 
<br /> 


</div>
)
}